import { useQuery } from '@tanstack/react-query'
import { useCogfy } from './use-cogfy'

export function useCreditsEndOfMonthForecast (
  workspace: string
) {
  const cogfy = useCogfy()

  const getCreditsEndOfMonthForecast = useQuery({
    queryKey: ['getCreditsEndOfMonthForecast', workspace],
    queryFn: ({ signal }) => cogfy.getCreditsEndOfMonthForecast({ signal })
  })

  return getCreditsEndOfMonthForecast
}
